import React from "react";
import PropTypes from "prop-types";

import ScaleForm from "../ScaleForm";

export const CreateScale = ({ handleCreateScale, closeModalDialog }) => {
  return (
    <ScaleForm
      initialValues={{ name: "" }}
      onSubmit={handleCreateScale}
      onCancel={closeModalDialog}
      sendButtonText="Create"
    />
  );
};

CreateScale.propTypes = {
  handleCreateScale: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};
